import {Link} from "@amzn/awsui-components-react";
import React from "react";

export function DemTeamLink() {
    return <Link
        external
        href={"https://w.amazon.com/bin/view/Alexa/Excellence/" +
            "Availability_and_Monitoring/Projects/DEM_Intro#HTeam"}
    > DEM Team</Link>
}